<template>
    <div class="msg-subscr-msanage">
        <div class="hint block mb10">
            <div class="title">温馨提示</div>
            <p>逐条检查：一条一条的检查，因数据较多花费时间较长</p>
        </div>
        <div class="hint block mb10">
            <p>逐条检查导入：一条一条的检查并导入，因数据较多花费时间较长</p>
        </div>
        <div class="hint block">
            <p>导入excel文件的单元格格式推荐使用常规或文本</p>
        </div>
        <div class="message-body mt10">
            <div class="hint block">
                <p>合同基本信息</p>
            </div>
            <ul class="native-table">
                <li class="table-tr">
                    <div class="table-th" style="text-align: left">列名</div>
                    <div class="table-th" style="width: 120px">是否必填</div>
                    <div class="table-th" style="text-align: left">其他要求</div>
                    <!--<div class="table-th" style="text-align: left">正确示例</div>-->
                    <div class="table-th">不符合要求的结果</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">买方公司</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">买方公司不可为空，可在系统中选择商户实体公司</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">合同名称</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">合同名称不可为空，可在系统中手动输入</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">合同编号</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">必填，系统中不可手动输入</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">供应商名称</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">根据供应商统一社会信用代码自动带出，供应商必须是入选供方公司</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td"></div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">卖方公司</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">卖方公司不可为空，可在系统中选择卖方商户实体公司且必须是入选供方公司</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">供应商统一社会信用代码</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">必填，友情提示：不要填错了</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">开始时间</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">必填，可在系统中进行选择，以系统的为准</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">结束时间</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">必填，可在系统中进行选择，以系统的为准</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">签署日期</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">必填，可在系统中进行选择，以系统的为准</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">到货期限（天）</div>
                    <div class="table-td">否</div>
                    <div class="table-td" style="text-align: left">可在系统中进行填写</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">税率(%)</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">必填，可在系统中手工输入</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
            </ul>
            <div class="hint block mt10">
                <p>资产信息</p>
            </div>
            <ul class="native-table">
                <li class="table-tr">
                    <div class="table-th" style="text-align: left">列名</div>
                    <div class="table-th" style="width: 120px">是否必填</div>
                    <div class="table-th" style="text-align: left">其他要求</div>
                    <!--<div class="table-th" style="text-align: left">正确示例</div>-->
                    <div class="table-th">不符合要求的结果</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">合同编号</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">必填，系统中不可手动输入，必须与合同基本信息中的合同编号相同</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">资产定义编码</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">必填，可在系统中手工输入</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">资产名称</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">根据资产定义编码对应的资产定义自动带出</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td"></div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">资产描述全称</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">根据资产定义编码对应的资产定义自动带出</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td"></div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">资产分类编码</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">根据资产定义编码对应的资产定义自动带出</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">品牌</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">根据资产定义编码对应的资产定义自动带出</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">单位</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">根据资产定义编码对应的资产定义自动带出</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">型号</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">根据资产定义编码对应的资产定义自动带出</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">规格</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">根据资产定义编码对应的资产定义自动带出</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">区域名称</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">可在系统中手工输入，输入后默认启动区域价格，输入后系统中找不到区域验证不通过</div>
                    <!-- <div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">区域编码</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">可在系统中手工输入，输入后默认启动区域价格</div>
                    <!-- <div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">-</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">含税价(元)</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">必填，可在系统中手工输入</div>
                    <!-- <div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">质保期(月)</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">必填，可在系统中手工输入</div>
                    <!-- <div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">经营业态</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">可在系统中进行选择以系统的为准,可多选按"|"分割，不为空的时候，系统中找不到对应的经营业态的时候验证不通过</div>
                    <!-- <div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">是否可定制</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">仅可在模板中手工输入，如违反了商品是否可定制需拦截：商家商品不可定制，请修改导入文件</div>
                    <!-- <div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
            </ul>
            <div class="hint block mt10">
                <p>组装件信息</p>
            </div>
            <ul class="native-table">
                <li class="table-tr">
                    <div class="table-th" style="text-align: left">列名</div>
                    <div class="table-th" style="width: 120px">是否必填</div>
                    <div class="table-th" style="text-align: left">其他要求</div>
                    <!--<div class="table-th" style="text-align: left">正确示例</div>-->
                    <div class="table-th">不符合要求的结果</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">合同编号</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">必填，系统中不可手动输入，必须与合同基本信息中的合同编号相同</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">组装件定义编码</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">必填，可在系统中手工输入</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">组装件名称</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">根据组装件定义编码对应的组装件定义自动带出</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td"></div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">组装件描述全称</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">根据组装件定义编码对应的组装件定义自动带出</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td"></div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">品牌</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">根据组装件定义编码对应的组装件定义自动带出</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">单位</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">根据组装件定义编码对应的组装件定义自动带出</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">型号</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">根据组装件定义编码对应的组装件定义自动带出</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">规格</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">根据组装件定义编码对应的组装件定义自动带出</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">区域名称</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">可在系统中手工输入，输入后默认启动区域价格，输入后系统中找不到区域验证不通过</div>
                    <!-- <div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">区域编码</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">可在系统中手工输入，输入后默认启动区域价格</div>
                    <!-- <div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">-</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">含税价(元)</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">必填，可在系统中手工输入</div>
                    <!-- <div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">质保期(月)</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">必填，可在系统中手工输入</div>
                    <!-- <div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">经营业态</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">可在系统中进行选择以系统的为准,可多选按"|"分割，不为空的时候，系统中找不到对应的经营业态的时候验证不通过</div>
                    <!-- <div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes} from '../../app.vues'

    export default {
        name: 'swb-contract-format-expl',
        desc: '合同导入文件格式说明',
        props: {
            scopeId: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {}
        },
    }
</script>



// WEBPACK FOOTER //
// src/compo/contract/ContractFormatExpl.vue